var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.75 10.45 8.99-9.33c.38-.39 1.03.02.83.53l-2.36 5.96c-.13.33.11.68.47.68h6.15c.43 0 .66.51.37.83L8.28 19.15c-.37.42-1.05 0-.84-.52l2.66-6.66a.503.503 0 0 0-.46-.69H3.11c-.44 0-.67-.53-.36-.85Z"
  })));
};
export default SvgBolt;